@if (level() === 0 || (item()?.items || []).length > 0) {
    <div class="flex items-center gap-2">
        <button (click)="onToggleExpanded(field(), item()?.id)" mat-icon-button>
            <mat-icon>{{ isExpanded(item()?.id) ? 'keyboard_arrow_down' : 'chevron_right' }}</mat-icon>
        </button>
        <div>
            {{ field()?.fieldName }}
        </div>
    </div>
}
@if (isExpanded(item()?.id)) {
    <div class="pl-2">
        @for (i of item()?.items || []; track i.id) {
            <div class="flex gap-2">
              <mat-checkbox (change)="onCheckedChange($event, i)">
                    {{ i.value }} ({{ i.count }})
                </mat-checkbox>

                @if (i.items && i.items.length > 0) {
                    <button mat-icon-button (click)="onToggleExpanded(field(), i.id)">
                        <mat-icon>{{ isExpanded(i.id) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                    </button>
                }
            </div>

            @if (isExpanded(i.id)) {
                @for (childItem of i.items; track childItem.id) {
                    <div class="pl-4">
                        <cat-facet-tree-item [level]="level() + 1"
                                             [coreId]="coreId()"
                                             (expand)="expand.emit($event)"
                                             (collapse)="collapse.emit($event)"
                                             (checkFacet)="onCheckFacet($event, i)"
                                             [expandedFacetTreeNodes]="expandedFacetTreeNodes()"
                                             [field]="getRegisterField(childItem.fieldId)"
                                             [item]="childItem"></cat-facet-tree-item>
                    </div>
                }
            }
        }
    </div>
}
